import React from 'react'

import Pin from "../../../../core/gd-components/pin/v2/pin"

// @ts-ignore
import UserIcon from "../../../../core/gd-components/icons/user-icon"
// @ts-ignore
import UserSectionMenu from "./submenu"

type Props = {
    companyUserId : ID
    curMenuId     : ID | null
    extensions?   : any[]
}

export default function TopUser(props: Props) {
    const companyUser   = gd.session.companyUsers.get(props.companyUserId)!
    const user          = companyUser.user
    const company       = companyUser.company

    return (
        <div className="ui5-app-header with-menu">

            <div className="left">

                <div className="flex-r fl-ac">

                    <div className="icon-left m-r-10">
                        <UserIcon user={user} size="26" hint={false} />
                    </div>

                    <div className="ui5-title-app-name max-w-500">
                        {user.name}
                    </div>

                    {!companyUser.isActivated &&
                        <div className="ui5-txt-less-important m-l-15 p-t-4">Pending invitation</div>
                    }

                </div>

            </div>

            <UserSectionMenu companyUser    = {companyUser}
                             curMenuId      = {props.curMenuId} />

            <div className="quick-controls">
                <Pin data={{
                    userId          : user.id,
                    organizationId  : company.id
                }}/>
            </div>

        </div>
    )

}
